module.exports = __webpack_public_path__ + "img/sdk-1-1.acb4a0d.svg";